<div 
class="nuty-bg invoiceList" 
[ngClass]="{ 'selected-item' : selectedInvoiceDetailsId == id }">
<div class="invoiceListData">
    <div class="lineData">{{ name }} {{ surname }}</div>
    <div class="lineData">{{ tax_number }}</div>
    <div class="lineData">{{ street }} {{ street_number }} {{ apartment_number }}</div>
    <div class="lineData">{{ postal_code }} {{ city }}</div>
   <!-- <div class="lineData">{{ country }}</div> -->
</div>

    <div *ngIf="!this._readonly && show_controls == 1" class="nuty-color invoiceListControls">
        <span style="cursor: pointer; margin-right: 6px;" (click)="edit()">
            {{ 'edit' | translate }}
        </span>
        <span style="cursor: pointer;" (click)="remove()">
            {{ 'delete' | translate }}
        </span>
    </div>
</div>